/**
 * Чистая логика Web Push (без DOM/axios) — unit-тесты.
 */

export function urlBase64ToUint8Array(base64String) {
  const raw = String(base64String || '').trim()
  if (!raw) return new Uint8Array()
  const padding = '='.repeat((4 - (raw.length % 4)) % 4)
  const base64 = (raw + padding).replace(/-/g, '+').replace(/_/g, '/')
  const binary = typeof atob === 'function'
    ? atob(base64)
    : Buffer.from(base64, 'base64').toString('binary')
  const out = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    out[i] = binary.charCodeAt(i)
  }
  return out
}

export function isWebPushSupported(g = globalThis) {
  return typeof g.Notification === 'function'
    && !!g.navigator?.serviceWorker
    && typeof g.PushManager === 'function'
}

export function subscriptionToPayload(subscription) {
  if (!subscription || typeof subscription.toJSON !== 'function') return null
  const json = subscription.toJSON()
  if (!json?.endpoint || !json.keys?.p256dh || !json.keys?.auth) return null
  return {
    endpoint: json.endpoint,
    keys: {
      p256dh: json.keys.p256dh,
      auth: json.keys.auth,
    },
  }
}

export function parseVapidKeyPayload(data) {
  if (!data || typeof data !== 'object') {
    return { enabled: false, publicKey: '' }
  }
  const enabled = data.enabled === true && typeof data.public_key === 'string' && data.public_key.length > 0
  return { enabled, publicKey: enabled ? data.public_key : '' }
}

export const WEB_PUSH_VAPID_STORAGE_KEY = 'erp-web-push-vapid'

export function readStoredVapidKey(storage = globalThis.localStorage) {
  try {
    return storage?.getItem?.(WEB_PUSH_VAPID_STORAGE_KEY) || ''
  } catch {
    return ''
  }
}

export function writeStoredVapidKey(publicKey, storage = globalThis.localStorage) {
  try {
    if (!publicKey) storage?.removeItem?.(WEB_PUSH_VAPID_STORAGE_KEY)
    else storage?.setItem?.(WEB_PUSH_VAPID_STORAGE_KEY, publicKey)
  } catch {
    // ignore quota / private mode
  }
}

/** Смена VAPID на сервере делает старую PushSubscription бесполезной. */
export function shouldReplacePushSubscription(storedKey, nextKey) {
  return !!nextKey && !!storedKey && storedKey !== nextKey
}

